var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 44,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "M10.5 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M23.077 15.857H9.231c-.85 0-1.539.688-1.539 1.536s.69 1.536 1.539 1.536h13.846a1.537 1.537 0 1 0 0-3.071M17.033 22H9.231a1.537 1.537 0 1 0 0 3.071h7.802c.85 0 1.538-.687 1.538-1.535S17.884 22 17.034 22"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "M6.838 3.572a3.76 3.76 0 0 0-3.761 3.76v29.336a3.76 3.76 0 0 0 3.76 3.76H22.07a13 13 0 0 1-.944-1.504H6.838a2.257 2.257 0 0 1-2.257-2.256V7.332a2.256 2.256 0 0 1 2.257-2.256H25.64a2.256 2.256 0 0 1 2.256 2.256V20.94q.732-.277 1.505-.463V7.332a3.76 3.76 0 0 0-3.76-3.76z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 1.5,
  d: "M30 40.813c4.886 0 8.846-3.954 8.846-8.83 0-4.878-3.96-8.831-8.846-8.831s-8.846 3.953-8.846 8.83 3.96 8.83 8.846 8.83Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m26.923 31.214 3.078 2.304 3.62-4.607"
})));
export default SvgGlobalProvide2;